"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ID: () => ID,
  Omneo: () => Omneo
});
module.exports = __toCommonJS(src_exports);

// src/omneo/resources/profiles/createProfileByDelegation.ts
function createProfileByDelegation(_0, _1, _2) {
  return __async(this, arguments, function* (client, body, delegation, options = {}) {
    const { type, url, enabled } = delegation;
    if (!enabled) return Promise.reject(new Error("Delegation not enabled"));
    const tokenData = yield client.call({
      method: "post",
      endpoint: "/auth/delegate",
      body: { client_handle: type }
    }).then((response) => {
      var _a;
      return (_a = response == null ? void 0 : response.data) == null ? void 0 : _a.token;
    });
    if (!tokenData) {
      return Promise.reject(new Error(`Failed to get token for delegate type ${type}`));
    }
    return fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${tokenData}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then((response) => response.json()).catch((error) => __async(this, null, function* () {
      var _a, _b, _c, _d;
      if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) !== 422 || !((_d = (_c = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.data) == null ? void 0 : _c.errors) == null ? void 0 : _d.mobile_phone)) {
        return Promise.reject(error);
      }
      if (!options.retryMobileSecondary) return;
      const payload = __spreadValues({}, body);
      payload.secondary_phone = payload.mobile_phone;
      delete payload.mobile_phone;
      const response = yield fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${client.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = yield response.json();
      return data.data;
    }));
  });
}
var createProfileByDelegation_default = createProfileByDelegation;

// src/omneo/resources/resource.ts
var Resource = class {
  constructor(client) {
    this.client = client;
  }
};

// src/omneo/resources/profiles/index.ts
var Profiles = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  findByIdentity(identifier, handle) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/search-id",
      body: { type: handle, id: identifier }
    }).then((response) => {
      return response.data;
    });
  }
  findByEmail(email, params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles",
      params: __spreadValues({ "filter[email]": email }, params)
    }).then((response) => {
      var _a;
      return (_a = response.data) == null ? void 0 : _a[0];
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles",
      params
    }).then((response) => {
      return response.data;
    });
  }
  update(id, body, options = {}) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${id}`,
      body
    }).then((response) => {
      return response.data;
    }).catch((error) => __async(this, null, function* () {
      var _a, _b;
      if ((error == null ? void 0 : error.status) !== 422 || !((_b = (_a = error == null ? void 0 : error.body) == null ? void 0 : _a.errors) == null ? void 0 : _b.mobile_phone)) {
        return Promise.reject(error);
      }
      if (!options.retryMobileSecondary) return;
      const payload = __spreadValues({}, body);
      payload.secondary_phone = payload.mobile_phone;
      delete payload.mobile_phone;
      return this.client.call({
        method: "put",
        endpoint: `/profiles/${id}`,
        body: payload
      });
    }));
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  purge(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${id}/purge`
    });
  }
  resync(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/resync`
    }).then((response) => {
      return response.data;
    });
  }
  checkAvailability(body) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/availability",
      body
    }).then((response) => {
      return response.data;
    });
  }
  create(body, options = {}) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles",
      body
    }).then((response) => {
      return response.data;
    }).catch((error) => __async(this, null, function* () {
      var _a, _b, _c, _d;
      if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) !== 422 || !((_d = (_c = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.data) == null ? void 0 : _c.errors) == null ? void 0 : _d.mobile_phone)) {
        return Promise.reject(error);
      }
      if (!options.retryMobileSecondary) return;
      const payload = __spreadValues({}, body);
      payload.secondary_phone = payload.mobile_phone;
      delete payload.mobile_phone;
      return this.client.call({
        method: "post",
        endpoint: "/profiles",
        body: payload
      }).then((response) => {
        return response.data;
      });
    }));
  }
  createByDelegation(_0, _1) {
    return __async(this, arguments, function* (body, delegation, options = {}) {
      return createProfileByDelegation_default(this.client, body, delegation, options);
    });
  }
  createIdentity(profileID, body) {
    return this.client.call({
      method: "post",
      endpoint: `/profiles/${profileID}/identities`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  getIdentities(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/identities`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getIdentityById(profileID, identityID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/identities/${identityID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateIdentity(profileID, identityID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/identities/id/${identityID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteIdentity(profileID, identityID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${profileID}/identities/id/${identityID}`
    }).then((response) => {
      return response.data;
    });
  }
  createInteraction(body) {
    return this.client.call({
      method: "post",
      endpoint: "/interactions",
      body
    }).then((response) => {
      return response.data;
    });
  }
  createAddress(profileID, body) {
    return this.client.call({
      method: "post",
      endpoint: `/profiles/${profileID}/addresses`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteAddress(profileID, addressID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${profileID}/addresses/${addressID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateAddress(profileID, addressID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/addresses/${addressID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  findIdentityInProfile(profile, options) {
    var _a;
    const { handle, identifier, findLatest } = options;
    const identities = profile == null ? void 0 : profile.identities;
    if (!(identities == null ? void 0 : identities.length)) return;
    const filteredIdentities = identities.filter((identity) => {
      if (handle && identity.handle !== handle) return false;
      if (identifier && identity.identifier !== identifier) return false;
      return true;
    });
    if (!findLatest) return filteredIdentities == null ? void 0 : filteredIdentities[0];
    return (_a = filteredIdentities.sort((identityA, identityB) => {
      return new Date(identityB.created_at).getTime() - new Date(identityA.created_at).getTime();
    })) == null ? void 0 : _a[0];
  }
  getRewards(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/rewards`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getPoints(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/points`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getInteractions(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/interactions`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getComms(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/attributes/comms`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getBalances(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/balances`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getAppearances(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/attributes/appearance`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getAggregations(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/aggregations`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  calculateAggregations(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/aggregations/calculate`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  isSubscribed(comms, prefix) {
    if (!prefix) throw Error("No Prefix provided");
    if (comms[`${prefix}_promo`] === false) return false;
    if (comms[`${prefix}_optout`] === true) return false;
    if (comms[`${prefix}_bounced`] === true) return false;
    return true;
  }
  isUnsubscribed(comms, prefix) {
    if (!prefix) throw Error("No Prefix provided");
    if (comms[`${prefix}_promo`] === false) return true;
    if (comms[`${prefix}_optout`] === true) return true;
    if (comms[`${prefix}_bounced`] === true) return true;
    return false;
  }
  subscribe(profileID, channel) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/comms`,
      body: {
        [`${channel}_optout`]: false,
        [`${channel}_promo`]: true
      }
    }).then((response) => {
      var _a;
      return (_a = response.data) == null ? void 0 : _a[0];
    });
  }
  unsubscribe(profileID, channel, options) {
    const body = {
      [`${channel}_promo`]: false
    };
    if (options.toggleOptOut) body[`${channel}_optout`] = true;
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/comms`,
      body
    }).then((response) => {
      var _a;
      return (_a = response.data) == null ? void 0 : _a[0];
    });
  }
  redeem(profileID, amount) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "post",
        endpoint: `/profiles/${profileID}/redeem`,
        body: { amount }
      }).then((response) => {
        return response.data;
      });
    });
  }
  getConnections(profileID, params) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/${profileID}/connections`,
        params
      }).then((response) => {
        return response.data;
      });
    });
  }
  getConnectionByID(profileID, connectionID) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/${profileID}/connections/${connectionID}`
      }).then((response) => {
        return response.data;
      });
    });
  }
  getConnectionProfileInfo(profileID, connectionID) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/${profileID}/connections/${connectionID}/profileInfo`
      }).then((response) => {
        return response.data;
      });
    });
  }
  getCustomAttribute(profileID, namespace, handle) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/${profileID}/attributes/custom/${namespace}:${handle}`
      }).then((response) => {
        return response.data;
      });
    });
  }
  getCustomAttributes(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/attributes/custom`
    }).then((response) => {
      return response.data;
    });
  }
  updateCustomAttribute(profileID, namespace, handle, body) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "put",
        endpoint: `/profiles/${profileID}/attributes/custom/${namespace}:${handle}`,
        body
      }).then((response) => {
        return response.data;
      });
    });
  }
  getProfileDates(profileID) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/${profileID}/attributes/dates`
      }).then((response) => {
        return response.data;
      });
    });
  }
  getTransactions(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/transactions`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getTransactionByID(profileID, transactionID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/transactions/${transactionID}`
    }).then((response) => {
      return response.data;
    });
  }
  findTransactions(profileID, filter) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/find-transactions`,
      params: {
        [`filter[${filter.field}]`]: filter.value
      }
    }).then((response) => {
      return response == null ? void 0 : response.data;
    }).catch((error) => {
      var _a;
      if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 404) return null;
      return error;
    });
  }
  getGroupedTransactions(profileID, params) {
    return __async(this, null, function* () {
      return this.client.call(__spreadValues(__spreadValues({
        method: "get",
        endpoint: `/profiles/${profileID}/group_transactions`
      }, (params == null ? void 0 : params.pageSize) && { "page[size]": params == null ? void 0 : params.pageSize }), (params == null ? void 0 : params.pageNumber) && { "page[number]": params == null ? void 0 : params.pageNumber }));
    });
  }
  getLedgers(profileID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/ledgers`
    }).then((response) => {
      return response.data;
    });
  }
  getLedgerById(profileID, ledgerID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/ledgers/${ledgerID}`
    }).then((response) => {
      return response.data;
    });
  }
  getRegions(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/regions`
    }).then((response) => {
      return response.data;
    });
  }
  calculateTiers(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${id}/tiers/calculate`
    }).then((response) => {
      return response.data;
    });
  }
  assignTier(profileID, tierDefinitionHandle) {
    return this.client.call({
      method: "post",
      endpoint: `/profiles/${profileID}/tiers/assign`,
      body: {
        tier: tierDefinitionHandle
      }
    }).then((response) => {
      return response.data;
    });
  }
  merge(sourceProfileID, destinationProfileId) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/merge",
      body: {
        source_profile_id: sourceProfileID,
        destination_profile_id: destinationProfileId
      }
    }).then((response) => {
      return response.data;
    });
  }
  getLists(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/lists`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getListByID(profileID, listID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/lists/${listID}`
    }).then((response) => {
      return response.data;
    });
  }
  deleteList(profileID, listID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${profileID}/lists/${listID}`
    }).then((response) => {
      return response.data;
    });
  }
  getListItems(profileID, listID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/lists/${listID}/items`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getListItemByID(profileID, listID, listItemID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/lists/${listID}/items/${listItemID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateListItem(profileID, listID, listItemID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/lists/${listID}/items/${listItemID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  createListItem(profileID, listID, listItemID, body) {
    return this.client.call({
      method: "post",
      endpoint: `/profiles/${profileID}/lists/${listID}/items/${listItemID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteListItem(profileID, listID, listItemID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/${profileID}/lists/${listID}/items/${listItemID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateList(profileID, listID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/${profileID}/lists/${listID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  getUnassignedTransactionItems(profileID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/${profileID}/transactionitems/list/unassigned`,
      params
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/orders/index.ts
var Orders = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/orders/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/orders",
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/orders",
      body
    }).then((response) => {
      return response.data;
    });
  }
  update(id, body) {
    return this.client.call({
      method: "put",
      endpoint: `/orders/${id}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/orders/${id}`
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/transactions/index.ts
var Transactions = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/transactions/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getByExternalID(externalID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/transactions/external/${externalID}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/transactions",
      body
    }).then((response) => {
      return response.data;
    });
  }
  update(id, body) {
    return this.client.call({
      method: "put",
      endpoint: `/transactions/${id}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  updateCreate(body) {
    if (body.receipt_is_email === null) delete body.receipt_is_email;
    if (body.is_void === null) delete body.is_void;
    return this.client.call({
      method: "post",
      endpoint: "/transactions/update-create",
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/transactions/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/transactions",
      params
    }).then((response) => {
      return response;
    });
  }
  queue(body) {
    return this.client.call({
      method: "post",
      endpoint: "/transactions/queue",
      body
    }).then((response) => {
      return response.data;
    });
  }
  resend(id) {
    return this.client.call({
      method: "post",
      endpoint: `/transactions/${id}resend`
    }).then((response) => {
      return response.data;
    });
  }
  resendItem(transactionItemID) {
    return this.client.call({
      method: "post",
      endpoint: `transactions/items/${transactionItemID}/resend`
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/products/index.ts
var Products = class extends Resource {
  get(id) {
    return this.client.call({
      method: "get",
      endpoint: `/products/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  getProductVariant(productID, variantID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/products/${productID}/variants/${variantID}`,
      params
    });
  }
  deleteProductVariant(productID, variantID) {
    return this.client.call({
      method: "delete",
      endpoint: `/products/${productID}/variants/${variantID}`
    });
  }
  updateProductVariant(productID, variantID, body) {
    return this.client.call({
      method: "put",
      body,
      endpoint: `/products/${productID}/variants/${variantID}`
    });
  }
  listProductVariants(productID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/products/${productID}/variants`,
      params
    });
  }
  listVariants(params) {
    return this.client.call({
      method: "get",
      endpoint: "/products/variants",
      params
    });
  }
  update(id, body) {
    return this.client.call({
      method: "put",
      endpoint: `/products/${id}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/products/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/products",
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/products",
      body
    }).then((response) => {
      return response.data;
    });
  }
  queue(body) {
    return this.client.call({
      method: "post",
      endpoint: "/products/queue",
      body
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/settings/index.ts
var Settings = class extends Resource {
  getEnvironment(params) {
    return this.client.call({
      method: "get",
      endpoint: "/settings/environment",
      params
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/locations/index.ts
var Locations = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/locations/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/locations",
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/locations",
      body
    }).then((response) => {
      return response.data;
    });
  }
  update(id, body) {
    return this.client.call({
      method: "put",
      endpoint: `/locations/${id}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/locations/${id}`
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/auth/index.ts
var Auth = class extends Resource {
  createAPIToken(body) {
    return this.client.call({
      method: "post",
      endpoint: "/auth/api-tokens",
      body
    }).then((response) => {
      const _a = response, { client, user } = _a, token = __objRest(_a, ["client", "user"]);
      return token;
    });
  }
  getAPITokens(params) {
    return this.client.call({
      method: "get",
      endpoint: "/auth/access-tokens",
      params
    }).then((response) => {
      return response;
    });
  }
  deleteAPIToken(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/auth/api-tokens/${id}`
    });
  }
};

// src/omneo/resources/tenants/index.ts
var Tenants = class extends Resource {
  getCustomFields(params) {
    return this.client.call({
      method: "get",
      endpoint: "/tenants/custom-fields",
      params
    }).then((response) => {
      return response.data;
    });
  }
  createCustomField(body) {
    return this.client.call({
      method: "post",
      endpoint: "/tenants/custom-fields",
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteCustomField(namespace, handle) {
    return this.client.call({
      method: "delete",
      endpoint: `/tenants/custom-fields/${namespace}:${handle}`
    });
  }
  updateCustomField(namespace, handle, body) {
    return this.client.call({
      method: "put",
      endpoint: `/tenants/custom-fields/${namespace}:${handle}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/connections/index.ts
var Connections = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/connections/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/connections",
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/connections",
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/connections/${id}`
    }).then((response) => {
      return response.data;
    });
  }
};

// src/omneo/resources/interactions/index.ts
var Interactions = class extends Resource {
  get(id, params) {
    return this.client.call({
      method: "get",
      endpoint: `/interactions/${id}`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  list(params) {
    return this.client.call({
      method: "get",
      endpoint: "/interactions",
      params
    }).then((response) => {
      return response.data;
    });
  }
  create(body) {
    return this.client.call({
      method: "post",
      endpoint: "/interactions",
      body
    }).then((response) => {
      return response.data;
    });
  }
  update(id, body) {
    return this.client.call({
      method: "put",
      endpoint: `/interactions/${id}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  delete(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/interactions/${id}`
    }).then(() => {
    });
  }
};

// src/omneo/index.ts
var Omneo = class {
  constructor(options) {
    this.profiles = new Profiles(this);
    this.orders = new Orders(this);
    this.transactions = new Transactions(this);
    this.products = new Products(this);
    this.settings = new Settings(this);
    this.locations = new Locations(this);
    this.auth = new Auth(this);
    this.tenants = new Tenants(this);
    this.connections = new Connections(this);
    this.interactions = new Interactions(this);
    const { config, tenant, token, baseURL } = options;
    this.tenant = tenant;
    this.config = config || {};
    this.token = token;
    this.baseURL = baseURL || `https://api.${tenant}.getomneo.com/api/v3`;
  }
  call(requestParams) {
    return __async(this, null, function* () {
      const { endpoint, params = {}, method, body } = requestParams;
      const queryParams = Object.keys(params).length && new URLSearchParams(params).toString();
      const url = `${this.baseURL}${endpoint}${queryParams ? `?${queryParams}` : ""}`;
      const headers = new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`
      });
      const response = yield fetch(url, __spreadValues({
        method,
        headers
      }, body && { body: JSON.stringify(body) }));
      if (!response.ok || response.status < 200 || response.status >= 300) {
        return Promise.reject(response);
      }
      try {
        const data = yield response.json();
        return data;
      } catch (e) {
        return null;
      }
    });
  }
};

// src/id/resources/resource.ts
var IDResource = class {
  constructor(client) {
    this.client = client;
  }
};

// src/id/resources/auth/index.ts
var Auth2 = class extends IDResource {
  // Id could be an omneo ID, or and identity (identifier) when id_handle is present
  requestAuthToken(body) {
    return fetch(`${this.client.baseURL}/auth/token`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.client.omneoAPIToken}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then((response) => response.json()).then(({ data }) => {
      this.client.IDToken = data == null ? void 0 : data.token;
      this.client.IDTokenExp = data == null ? void 0 : data.exp;
      return data;
    });
  }
  isTokenExpired() {
    if (!this.client.IDTokenExp) return true;
    const currentTime = Math.floor(Date.now() / 1e3);
    return this.client.IDTokenExp < currentTime;
  }
  getProfileID() {
    const tokenParts = this.client.IDToken.split(".");
    const encodedPayload = tokenParts[1];
    const tokenData = JSON.parse(Buffer.from(encodedPayload, "base64").toString("utf-8"));
    return tokenData == null ? void 0 : tokenData.pid;
  }
};

// src/id/resources/profile/index.ts
var Profile = class _Profile extends IDResource {
  get() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me"
    }).then(({ data }) => data);
  }
  update(body) {
    return this.client.call({
      method: "put",
      endpoint: "/profiles/me",
      body
    }).then(({ data }) => data);
  }
  delete() {
    return this.client.call({
      method: "delete",
      endpoint: "/profiles/me"
    });
  }
  purge() {
    return this.client.call({
      method: "delete",
      endpoint: "/profiles/me/purge"
    });
  }
  getInteractions(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/interactions",
      params
    });
  }
  getInteractionById(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/interactions/${id}`
    });
  }
  updateInteraction(id) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/me/interactions/${id}`
    });
  }
  createInteraction(body) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/me/interactions",
      body
    });
  }
  deleteInteraction(id) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/me/interactions/${id}`
    });
  }
  getAggregations(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/aggregations",
      params
    }).then((response) => {
      return response.data;
    });
  }
  calculateAggregations(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/aggregations/calculate",
      params
    }).then((response) => {
      return response.data;
    });
  }
  getBalances(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/balances",
      params
    }).then((response) => {
      return response.data;
    });
  }
  findTransactions(filter) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/find-transactions",
      params: {
        [`filter[${filter.field}]`]: filter.value
      }
    }).then((response) => {
      return response == null ? void 0 : response.data;
    }).catch((error) => {
      if ((error == null ? void 0 : error.status) === 404) return null;
      return error;
    });
  }
  getGroupedTransactions(params) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: "/profiles/me/group_transactions",
        params: __spreadValues(__spreadValues({}, (params == null ? void 0 : params.pageSize) && { "page[size]": params == null ? void 0 : params.pageSize }), (params == null ? void 0 : params.pageNumber) && { "page[number]": params == null ? void 0 : params.pageNumber })
      });
    });
  }
  createIdentity(body) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/me/identities",
      body
    }).then((response) => {
      return response.data;
    });
  }
  getIdentities() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/identities"
    }).then((response) => {
      return response.data;
    });
  }
  getIdentityById(identityID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/identities/id/${identityID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateIdentity(identityID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/me/identities/id/${identityID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteIdentity(identityID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/me/identities/id/${identityID}`
    }).then((response) => {
      return response.data;
    });
  }
  getLedgers() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/ledgers"
    }).then((response) => {
      return response.data;
    });
  }
  getLedgerById(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/ledgers/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add linked Points
  // getLinkedPoints () {
  //   console.log('linked_points')
  // }
  // TODO Add linked Redemptions
  // getLinkedRedemptions () {
  //   console.log('linked_redemptions')
  // }
  // TODO Add get Points
  // getPoints () {
  //   console.log('points')
  // }
  // TODO Add get Points by ID
  // getPointsByID () {
  //   console.log('points_id')
  // }
  getRegions() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/regions"
    }).then((response) => {
      return response.data;
    });
  }
  resync() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/resync"
    }).then((response) => {
      return response.data;
    });
  }
  getRewards(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/rewards",
      params
    }).then((response) => {
      return response.data;
    });
  }
  getTiers(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/tiers",
      params
    }).then((response) => {
      return response.data;
    });
  }
  calculateTiers() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/tiers/calculate"
    }).then((response) => {
      return response.data;
    });
  }
  assignTier(tierDefinitionHandle) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/me/tiers/assign",
      body: {
        tier: tierDefinitionHandle
      }
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add get Transaction Products
  // getTransactionProducts () {
  //   console.log('transaction_products')
  // }
  getTransactions() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/transactions"
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add get Transaction Claims by ID
  // getTransactionClaims () {
  //   console.log('transactions_claims')
  // }
  // TODO Add get Transaction Claim by ID
  // getTransationClaimByID () {
  //   console.log('transactions_claims_transactionClaim')
  // }
  getTransactionByID(id) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/transactions/${id}`
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add Update Type
  // updateType () {
  //   console.log('update_type')
  // }
  // TODO Ad Custom Event
  // customEvent () {
  //   console.log('custom_event')
  // }
  getComms() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/attributes/comms"
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add Dates
  // getDates () {
  //   console.log('attributes_dates')
  // }
  // TODO Add Dates by Attribute
  // getDatesByAttribute () {
  //   console.log('attributes_dates_datesAttribute')
  // }
  getAppearances() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/attributes/appearance"
    }).then((response) => {
      return response.data;
    });
  }
  getCustomAttribute(namespace, handle) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "get",
        endpoint: `/profiles/me/attributes/custom/${namespace}:${handle}`
      }).then((response) => {
        return response.data;
      });
    });
  }
  getCustomAttributes() {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/attributes/custom"
    }).then((response) => {
      return response.data;
    });
  }
  updateCustomAttribute(namespace, handle, body) {
    return __async(this, null, function* () {
      return this.client.call({
        method: "put",
        endpoint: `/profiles/me/attributes/custom/${namespace}:${handle}`,
        body
      }).then((response) => {
        return response.data;
      });
    });
  }
  // TODO Add Redeem Benefit
  // redeemBenefit () {
  //   console.log('benefits_benefit_redeem')
  // }
  // Todo Add Redeem
  // redeem () {
  //   console.log('redeem')
  // }
  getConnections(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/connections",
      params
    }).then((response) => {
      return response.data;
    });
  }
  getConnectionByID(connectionID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/connections/${connectionID}`
    }).then((response) => {
      return response.data;
    });
  }
  createList(body) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/me/lists",
      body
    }).then((response) => {
      return response.data;
    });
  }
  getLists(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/lists",
      params
    }).then((response) => {
      return response.data;
    });
  }
  getListByID(listID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/lists/${listID}`
    }).then((response) => {
      return response.data;
    });
  }
  deleteList(listID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/me/lists/${listID}`
    }).then((response) => {
      return response.data;
    });
  }
  getListItems(listID, params) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/lists/${listID}/items`,
      params
    }).then((response) => {
      return response.data;
    });
  }
  getListItemByID(listID, listItemID) {
    return this.client.call({
      method: "get",
      endpoint: `/profiles/me/lists/${listID}/items/${listItemID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateListItem(listID, listItemID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/me/lists/${listID}/items/${listItemID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  linkTransactionItemToList(transactionItemID, body) {
    return this.client.call({
      method: "post",
      endpoint: `/profile/transactions/items/${transactionItemID}/list-item`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  createListItem(listID, body) {
    return this.client.call({
      method: "post",
      endpoint: `/profiles/me/lists/${listID}/items`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  deleteListItem(listID, listItemID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/me/lists/${listID}/items/${listItemID}`
    }).then((response) => {
      return response.data;
    });
  }
  updateList(listID, body) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/me/lists/${listID}`,
      body
    }).then((response) => {
      return response.data;
    });
  }
  createConnection(body) {
    return this.client.call({
      method: "post",
      endpoint: "/profiles/me/connections",
      body
    }).then((response) => {
      return response.data;
    });
  }
  updateConnection(connectionID) {
    return this.client.call({
      method: "put",
      endpoint: `/profiles/me/connections/${connectionID}`
    }).then((response) => {
      return response.data;
    });
  }
  deleteConnection(connectionID) {
    return this.client.call({
      method: "delete",
      endpoint: `/profiles/me/connections/${connectionID}`
    }).then((response) => {
      return response.data;
    });
  }
  Connection(connectionID) {
    const Conn = new _Profile(this.client);
    const clonedCall = Conn.client.call.bind(this.client);
    Conn.client.call = (options) => __async(this, null, function* () {
      options.endpoint = options.endpoint.replace("/profiles/me", `/profiles/connection/${connectionID}`);
      return clonedCall(options);
    });
    return Conn;
  }
  getUnassignedTransactionItems(params) {
    return this.client.call({
      method: "get",
      endpoint: "/profiles/me/transactionitems/list/unassigned",
      params
    }).then((response) => {
      return response.data;
    });
  }
  // TODO Add Get Connection Profile Info
  // getConnectionProfileInfo () {
  //   console.log('connections_connection_profileInfo')
  // }
  // TODO Add Get Transaction List Type
  // getTransactionItemsListType () {
  //   console.log('transactionitems_list_type')
  // }
  // TODO Add Get Transaction Items List Item
  // getTransactionItemsListItem () {
  //   console.log('transactions_items_transactionitem_list_item')
  // }
  // TODO Add Get Grouped Orders
  // getGroupedOrders () {
  //   console.log('group_orders')
  // }
};

// src/id/index.ts
var ID = class {
  constructor(options) {
    this.auth = new Auth2(this);
    this.profile = new Profile(this);
    const { config, tenant, IDToken, IDTokenExpiry, omneoAPIToken } = options;
    this.tenant = tenant;
    this.config = config || {};
    this.omneoAPIToken = omneoAPIToken || "";
    this.IDToken = IDToken || "";
    this.baseURL = `https://api.${tenant}.getomneo.com/id/api/v1`;
    if (IDTokenExpiry) this.IDTokenExp = IDTokenExpiry;
  }
  call(requestParams) {
    return __async(this, null, function* () {
      const { endpoint, params = {}, method, body } = requestParams;
      const queryParams = Object.keys(params).length && new URLSearchParams(params).toString();
      const url = `${this.baseURL}${endpoint}${queryParams ? `?${queryParams}` : ""}`;
      const headers = new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.IDToken}`
      });
      const response = yield fetch(url, __spreadValues({
        method,
        headers
      }, body && { body: JSON.stringify(body) }));
      if (!response.ok || response.status < 200 || response.status >= 300) {
        return Promise.reject(response);
      }
      try {
        const data = yield response.json();
        return data;
      } catch (e) {
        return null;
      }
    });
  }
  reset() {
    this.IDToken = "";
    this.IDTokenExp = void 0;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ID,
  Omneo
});
